import React, { createContext } from "react";

export const UserInfoContext = createContext({
  userInfoData: null,
  userProfileData: null,
  userCompanyData: null,
  showNotifications: {
    showToast: false,
    toastType: "success",
    toastMessage: ""
  },
  showCreateTerms: {
    docsLength: false,
    showModal: false
  },
  openPrivacyNotice: false,
  setUserData: () => { },
  setUserProfileData: () => { },
  setUserCompanyData: () => { },
  setShowNotifications: () => { },
  setShowCreateTerms: () => { },
  setOpenPrivacyNotice: () => { },
  refetchUserProfile: () => { }
});
export const EditorInfoContext = createContext({
  editEnabled: false,
  openAddElement: false,
  rectangle: {},
  activeRectangleIndex: null,
  geo: {},
  elements: {},
  editElement: {},
  openRemoveModal: false,
  pageNumber: 1,
  editLightBox: {},
  lightBoxList: [],
  imageElement: {},
  openLightBox: false,
  selectedPdf: '',
  showToast: {},
  tagValue: true,
  pageDimensions: {},
  isActionDisabled : false ,        
  setIsActionDisabled : ()=>{},     
});
export default UserInfoContext;
